import { Box as BoxMui } from '@mui/material';
import React from 'react';

export type BoxProps = {
  ref?: React.Ref<unknown>;
  className?: string;
  children?: React.ReactNode;
  id?: string;
  onClick?: VoidFunction;
};

export const Box: React.FC<BoxProps> = ({
  ref,
  id,
  className,
  children,
  onClick,
}) => {
  if (children) {
    return (
      <BoxMui
        id={id}
        ref={ref}
        component={onClick ? 'button' : 'div'}
        onClick={onClick}
        className={className}
      >
        {children}
      </BoxMui>
    );
  }
  return <BoxMui className={className} />;
};
